const permissions = {
  listSim: 'UP005',
  addSim: 'UP006',
  editSim: 'UP007',
  removeSim: 'UP008',
  reactivateSim: 'UP038'
};

export default permissions;
